import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, ReplaySubject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { EmployeeActivity } from 'src/app/employee/models/EmployeeActivity';
import { File } from 'src/app/employee/models/File';
import { FlatpickrHelper } from 'src/app/shared/common/FlatpickrHelper';
import { Role } from '../../../../setting/models/Role';
import { RolesService } from '../../../../setting/services/roles.service';
import { ParentOfComponent } from '../../../../ui/parent-component/components/parent-of.component';

@Component({
    selector: 'app-create-edit-employee-activity',
    templateUrl: './create-edit-employee-activity-modal.component.html',
    styleUrls: ['./create-edit-employee-activity-modal.component.css']
})
export class CreateEditEmployeeActivityModalComponent extends ParentOfComponent implements OnInit {
    public canEdit: boolean;
    public employeeID: number;
    public files$: Observable<Array<File>>;
    public form: UntypedFormGroup;
    public submitted = false;
    public type = 'EMPLOYEE';
    public recruitmentID?: number;
    public employeeRoles$: Observable<Role[]>;

    private _fetchFiles$ = new ReplaySubject<void>(1);

    public constructor(
        public activeModal: NgbActiveModal,
        private _roleService: RolesService,
    ) {
        super();
    }

    private _activity: EmployeeActivity | undefined;

    public get activity(): EmployeeActivity | undefined {
        return this._activity;
    }

    public set activity(activity: EmployeeActivity) {
        this._activity = activity;
    }

    public get f(): { [formControlName: string]: AbstractControl; } {
        return this.form.controls;
    }

    public ngOnInit(): void {
        this.canEdit = this.authService.checkPermission('employeeActivity.edit');

        this.employeeRoles$ = this._roleService.getAllRoles(null, 'select');

        this.files$ = this._fetchFiles$
            .pipe(switchMap(() => this.employeeService.getAllFilesByActivity(this.activity)));

        this.form = this.fb.group({
            description: [''],
            name: ['', Validators.required],
            type: [this.type === 'EMPLOYEE' ? 'NOTE' : 'INTERVIEW', Validators.required],
            notify: [false],
            is_pinned: [false],
            visible_for_roles: [[]],
            visible_for_employee: [false],
        });

        if (this.activity) {
            this._prefillForm(this.activity);

            if (!this.canEdit) {
                this.form.disable();
            }
        }
    }

    public deleteActivity(): void {
        this.employeeService.deleteActivity(this.employeeID, this.activity.employee_activity_ID)
            .then(() => this.activeModal.close('close'))
            .catch(() => { });
    }

    public fetchFiles(): void {
        this._fetchFiles$.next();
    }

    public onSubmit(): void {
        this.submitted = true;

        const formBody = {...this.form.value};

        if (this.recruitmentID) {
            formBody.recruitment_ID = this.recruitmentID;
        }

        if (this.form.valid) {
            this.employeeService.saveActivity(formBody, this.employeeID, this.activity?.employee_activity_ID)
                .then(() => this.activeModal.close('close'));
        }
    }

    private _prefillForm(activity: EmployeeActivity): void {
        if (activity) {
            this.form.patchValue(this.activity);
            this.fetchFiles();
        }
    }
}
